const redirectToCorrectHome = (customerTags) => {
    const path = window.location.pathname;
    if (customerTags && (path == '/' || path == '/account')) {
        if (customerTags.includes('nails') && customerTags.includes('cosmetics')) {
            if (!localStorage.getItem('selectedBrand')) {
                window.location.replace('/pages/select-brand');
            } else {
                window.location.replace(`/pages/${localStorage.getItem('selectedBrand')}`);
            }
        } else {
            const sparkData = localStorage.getItem('sparkLayerData')
                ? JSON.parse(localStorage.getItem('sparkLayerData'))
                : null;
            if (customerTags.includes('nails')) {
                localStorage.setItem('selectedBrand', 'nails');
                if (sparkData.userData && sparkData.userData.salesAgent && !sparkData.impersonatorUserData) {
                    window.location.replace('/pages/nails#spark-account');
                } else {
                    window.location.replace('/pages/nails');
                }
            }
            if (customerTags.includes('cosmetics')) {
                localStorage.setItem('selectedBrand', 'cosmetics');
                if (sparkData.userData && sparkData.userData.salesAgent && !sparkData.impersonatorUserData) {
                    window.location.replace('/pages/cosmetics#spark-account');
                } else {
                    window.location.replace('/pages/cosmetics');
                }
            }
        }
    }
    if (customerTags) {
        if (
            customerTags.includes('nails') &&
            customerTags.includes('cosmetics') &&
            path !== '/' &&
            path !== '/pages/select-brand'
        ) {
            if (!localStorage.getItem('selectedBrand')) {
                window.location.replace('/pages/select-brand');
            }
        }
    }
};

const goTo = (brand) => {
    localStorage.setItem('selectedBrand', brand);
    const sparkLayerData = localStorage.getItem('sparkLayerData')
        ? JSON.parse(localStorage.getItem('sparkLayerData'))
        : null;
    if (!sparkLayerData || !sparkLayerData.impersonatorUserData) {
        window.location.replace(`/pages/${brand}#spark-account`);
    } else {
        window.location.replace(`/pages/${brand}`);
    }
};

const goToCorrectPage = (customerTags) => {
    if (customerTags.includes('nails') && customerTags.includes('cosmetics') && localStorage.getItem('selectedBrand')) {
        window.location.replace(`/pages/${localStorage.getItem('selectedBrand')}`);
    } else {
        if (customerTags.includes('nails')) {
            localStorage.setItem('selectedBrand', 'nails');
            window.location.replace('/pages/nails');
        }
        if (customerTags.includes('cosmetics')) {
            localStorage.setItem('selectedBrand', 'cosmetics');
            window.location.replace('/pages/cosmetics');
        }
    }
};

const setNailsHeader = () => {
    if (document.querySelector('header-drawer#cosmetics')) {
        document.querySelector('header-drawer#cosmetics').remove();
    }
    if (document.querySelector('nav#cosmetics')) {
        document.querySelector('nav#cosmetics').remove();
    }
    if (document.querySelector('.header-wrapper')) {
        document.querySelector('.header-wrapper').classList.add('color-nails');
    }
    if (document.querySelector('.header__heading-logo')) {
        document.querySelector('.header__heading-logo').src =
            'https://cdn.shopify.com/s/files/1/0746/1981/4181/files/MNP-logo-black.svg?v=1683206356';
    }
};

const setNailsSocial = () => {
    return;
    console.log('setNailsSocial');
    // if (document.querySelector('.footer__list-social .list-social__item .icon-facebook')) {
    //     const iconFacebook = document.querySelector(
    //         '.footer__list-social .list-social__item .icon-facebook',
    //     ).parentElement;
    //     iconFacebook.href = 'https://www.facebook.com/mesaudanailpro';
    // }
};

const setNailsAnnouncement = () => {
    const announcementBar = document.querySelector('.announcement-bar');
    const nailsDlLink = document.querySelector('#catalog-dl-link-nails');
    const makeupDlLink = document.querySelector('#catalog-dl-link-makeup');
    if (announcementBar) {
        announcementBar.classList.add('color-nails');
        nailsDlLink.classList.remove('hidden');
        makeupDlLink.remove();
        //document.querySelector('.announcement-bar > p').innerHTML = `Hai terminato l'ordine? <span onClick="goTo('cosmetics')">Passa a Cosmetics</span>`
    }
};

const setCosmeticsHeader = () => {
    if (document.querySelector('header-drawer#nails')) {
        document.querySelector('header-drawer#nails').remove();
    }
    if (document.querySelector('nav#nails')) {
        document.querySelector('nav#nails').remove();
    }
    if (document.querySelector('.header-wrapper')) {
        document.querySelector('.header-wrapper').classList.add('color-cosmetics');
    }
    if (document.querySelector('.header__heading-logo')) {
        document.querySelector('.header__heading-logo').src =
            'https://cdn.shopify.com/s/files/1/0746/1981/4181/files/Mesauda-logo-white.svg?v=1683212242';
    }
};

const setCosmeticsAnnouncement = () => {
    const announcementBar = document.querySelector('.announcement-bar');
    const nailsDlLink = document.querySelector('#catalog-dl-link-nails');
    const makeupDlLink = document.querySelector('#catalog-dl-link-makeup');
    if (announcementBar) {
        announcementBar.classList.add('color-cosmetics');
        makeupDlLink.classList.remove('hidden');
        nailsDlLink.remove();
        //document.querySelector('.announcement-bar > p').innerHTML = `Hai terminato l'ordine? <span onClick="goTo('nails')">Passa a Nail Pro</span>`
    }
};

const renderCorrectVisual = () => {
    const selectedBrand = localStorage.getItem('selectedBrand');
    if (selectedBrand) {
        if (selectedBrand == 'nails' && window.location.pathname.includes('pages/cosmetics')) {
            window.location.replace('/pages/nails');
        }
        if (selectedBrand == 'cosmetics' && window.location.pathname.includes('pages/nail')) {
            window.location.replace('/pages/cosmetics');
        }
        if (selectedBrand == 'nails') {
            setNailsHeader();
            setNailsAnnouncement();
            setNailsSocial();
        } else {
            setCosmeticsHeader();
            setCosmeticsAnnouncement();
        }
        const stickyHeader = document.querySelector('sticky-header');
        if (stickyHeader) {
            stickyHeader.style.opacity = 1;
        }
        const homeBanner = document.querySelector('.banner');
        if (homeBanner) {
            homeBanner.style.opacity = 1;
        }

        if (document.querySelector('.loader-modal')) {
            document.querySelector('.loader-modal').style.display = 'none';
        }
    }
};

window.addEventListener('load', () => {
    const path = window.location.pathname;
    if (path.includes('account/activate')) {
        return;
    }
    if (!localStorage.sparkLayerData && localStorage.selectedBrand && path.includes('login')) {
        localStorage.removeItem('selectedBrand');
        if (localStorage.getItem('cartType')) {
            localStorage.removeItem('cartType');
        }
    }

    renderCorrectVisual();
});

const redirectToHome = (mainCategory) => {
    const brand = localStorage.getItem('selectedBrand');
    if (mainCategory && brand) {
        if (mainCategory !== brand) {
            window.location.replace(`/pages/${brand}`);
        }
    }
};

const setRegisterProspectImages = (cosmeticsImg, nailsImg) => {
    const brand = localStorage.getItem('selectedBrand');
    if (brand) {
        if (brand == 'nails') {
            document.querySelector('#imgDesktop').style.backgroundImage = `url('${nailsImg}')`;
            document.querySelector('#logoBrand').src =
                'https://cdn.shopify.com/s/files/1/0746/1981/4181/files/MNP-logo-black.svg?v=1683206356';
            document.querySelector('#CustomerTags').value = 'nails';
            // document.querySelector('#CustomerPassword').value = Math.random().toString(36).slice(2)
        }
        if (brand == 'cosmetics') {
            document.querySelector('#imgDesktop').style.backgroundImage = `url('${cosmeticsImg}')`;
            document.querySelector('#logoBrand').src =
                'https://cdn.shopify.com/s/files/1/0746/1981/4181/files/Mesauda-logo-black.svg?v=1683206356';
            document.querySelector('#CustomerTags').value = 'cosmetics';
            // document.querySelector('#CustomerPassword').value = Math.random().toString(36).slice(2)
        }
    }
};

const resetMessages = () => {
    const messageError = document.querySelector('.form__message.error');
    const messageSuccess = document.querySelector('.form__message.success');
    messageSuccess.style.visibility = 'hidden';
    messageSuccess.style.height = '0';
    messageSuccess.style.margin = '0';
    messageError.style.visibility = 'hidden';
    messageError.style.height = '0';
    messageError.style.margin = '0';
    messageError.querySelector('span').innerHTML =
        'Errore durante la registrazione. Ricontrolla i dati inseriti oppure la tua connessione.';
};

const removeListener = (event) => {
    event.returnValue = 'Close prompt!';
};

const createShopifyCustomer = (formDatas) => {
    return new Promise((resolve, reject) => {
        let shopifyHeaders = new Headers();
        shopifyHeaders.append('Content-Type', 'application/json');
        shopifyHeaders.append('X-Shopify-Access-Token', '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');

        const requestOptions = {
            method: 'POST',
            headers: shopifyHeaders,
            body: JSON.stringify(formDatas),
            redirect: 'follow',
        };

        fetch('https://b2b-mesauda.myshopify.com/admin/api/2023-04/customers.json', requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result && result.customer) {
                    const customer = result.customer;
                    const sparklayerObject = {
                        first_name: customer.first_name,
                        last_name: customer.last_name,
                        email: customer.email,
                        company_name: customer.default_address.company,
                        external_id: customer.id.toString(),
                        group: 'prospect',
                        sales_agent_groups: [document.querySelector('#CustomerSaleGroup').value],
                        vatin_number: [document.querySelector('#CustomerVAT').value],
                        addresses: customer.addresses.map((address) => {
                            return {
                                external_id: address.id.toString(),
                                first_name: customer.first_name,
                                last_name: customer.last_name,
                                address_line1: address.address1,
                                city: address.city,
                                postal_code: address.zip,
                                country_code: address.country_code,
                            };
                        }),
                    };
                    resolve(sparklayerObject);
                } else {
                    if (result.errors) {
                        reject(result);
                    } else {
                        reject('error');
                    }
                }
            })
            .catch((error) => reject(error));
    });
};

const sparkLayerAuthenticate = () => {
    return new Promise((resolve, reject) => {
        const sparkLayerAuthObject = {
            grant_type: 'client_credentials',
            client_id: 'c25361b2-d434-4104-9511-07eece39d82c',
            client_secret: 'a54hTalzuTFTqzAIJsg8Ea4Ei7zqCFrFv2aLoUiRYBvw2kYkG7G5NYUCbFGaO5fQ',
        };
        let sparkLayerAuthHeaders = new Headers();
        sparkLayerAuthHeaders.append('Content-Type', 'application/json');
        sparkLayerAuthHeaders.append('Site-Id', 'mesaudacosmetics');
        sparkLayerAuthHeaders.append('Host', 'app.sparklayer.io');
        sparkLayerAuthHeaders.append('User-Agent', 'mesaudacosmetics');
        const sparkLayerAuthRequestOptions = {
            method: 'POST',
            headers: sparkLayerAuthHeaders,
            body: JSON.stringify(sparkLayerAuthObject),
            redirect: 'follow',
        };
        fetch('https://app.sparklayer.io/api/auth/token', sparkLayerAuthRequestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result && result.access_token) {
                    resolve(result.access_token);
                } else {
                    reject('error');
                }
            })
            .catch((error) => reject(error));
    });
};

const createSparkLayerCustomer = (token, customerData) => {
    return new Promise((resolve, reject) => {
        let sparkLayerHeaders = new Headers();
        sparkLayerHeaders.append('Content-Type', 'application/json');
        sparkLayerHeaders.append('Site-Id', 'mesaudacosmetics');
        sparkLayerHeaders.append('Host', 'app.sparklayer.io');
        sparkLayerHeaders.append('User-Agent', 'mesaudacosmetics');
        sparkLayerHeaders.append('Authorization', `Bearer ${token}`);
        const sparkLayerRequestOptions = {
            method: 'POST',
            headers: sparkLayerHeaders,
            body: JSON.stringify(customerData),
            redirect: 'follow',
        };
        fetch(`https://app.sparklayer.io/api/v1/customers`, sparkLayerRequestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result && result.id) {
                    resolve(result.id);
                } else {
                    reject('error');
                }
            })
            .catch((error) => reject(error));
    });
};

const showErrorProspectMessage = () => {
    const messageError = document.querySelector('.form__message.error');
    if (messageError) {
        messageError.style.visibility = 'visible';
        messageError.style.height = 'auto';
        messageError.style.margin = '16px 0';
    }
};

const addCustomer = () => {
    const messageError = document.querySelector('.form__message.error');
    const messageSuccess = document.querySelector('.form__message.success');
    const countryCode = document.querySelector('#CustomerCountries').value;
    resetMessages();
    for (const elementInput of document.querySelectorAll('#formRegisterProspect .field input')) {
        if (!elementInput.value) {
            showErrorProspectMessage();
            messageError.querySelector('span').innerHTML = 'Compila tutti i campi del form';
            return;
        }
    }
    if (countryCode == '-') {
        showErrorProspectMessage();
        messageError.querySelector('span').innerHTML = 'Compila tutti i campi del form';
        return;
    }

    const formDatas = {
        customer: {
            first_name: document.querySelector('#CustomerFirstName').value,
            last_name: document.querySelector('#CustomerLastName').value,
            email: `${document.querySelector('#CustomerTags').value}_${document.querySelector('#CustomerEmail').value}`,
            phone: document.querySelector('#CustomerPhone').value,
            verified_email: true,
            send_email_welcome: true,
            tags: [document.querySelector('#CustomerTags').value, 'b2b', 'b2b-prospect'],
            addresses: [
                {
                    address1: document.querySelector('#CustomerAddress').value,
                    city: document.querySelector('#CustomerCity').value,
                    phone: document.querySelector('#CustomerPhone').value,
                    zip: document.querySelector('#CustomerZIP').value,
                    last_name: document.querySelector('#CustomerLastName').value,
                    first_name: document.querySelector('#CustomerFirstName').value,
                    company: document.querySelector('#CustomerCompany').value,
                    country_code: document.querySelector('#CustomerCountries').value,
                },
                {
                    address1: document.querySelector('#CustomerBillingAddress').value,
                    city: document.querySelector('#CustomerBillingCity').value,
                    phone: document.querySelector('#CustomerPhone').value,
                    zip: document.querySelector('#CustomerBillingZIP').value,
                    last_name: document.querySelector('#CustomerLastName').value,
                    first_name: document.querySelector('#CustomerFirstName').value,
                    company: document.querySelector('#CustomerCompany').value,
                    country_code: document.querySelector('#CustomerBillingCountries').value,
                },
            ],
            metafields: [
                {
                    key: 'vat',
                    value: document.querySelector('#CustomerVAT').value,
                    namespace: 'connector',
                    type: 'single_line_text_field',
                },
                {
                    key: 'sales_agent_groups',
                    value: JSON.stringify([document.querySelector('#CustomerSaleGroup').value]),
                    namespace: 'sparklayer',
                    type: 'list.single_line_text_field',
                },
                {
                    key: 'notes1',
                    value: document.querySelector('#CustomerNotes1').value,
                    namespace: 'connector',
                    type: 'multi_line_text_field',
                },
                {
                    key: 'notes2',
                    value: document.querySelector('#CustomerNotes2').value,
                    namespace: 'connector',
                    type: 'multi_line_text_field',
                },
                {
                    key: 'new_prospect',
                    value: true,
                    namespace: 'connector',
                    type: 'boolean',
                },
            ],
        },
    };

    window.addEventListener('beforeunload', removeListener);

    createShopifyCustomer(formDatas)
        .then((resultObject) => {
            sparkLayerAuthenticate()
                .then((resultToken) => {
                    createSparkLayerCustomer(resultToken, resultObject)
                        .then((id) => {
                            window.spark
                                .switchImpersonatingCustomer(id)
                                .then(() => {
                                    messageSuccess.style.visibility = 'visible';
                                    messageSuccess.style.height = 'auto';
                                    messageSuccess.style.margin = '16px 0';
                                    for (const input of document.querySelectorAll(
                                        '.formRegisterProspect .field > input',
                                    )) {
                                        input.value = '';
                                    }
                                    for (const textarea of document.querySelectorAll(
                                        '.formRegisterProspect .field > textarea',
                                    )) {
                                        textarea.value = '';
                                    }
                                    for (const textarea of document.querySelectorAll(
                                        '.formRegisterProspect .field > select',
                                    )) {
                                        textarea.value = '-';
                                    }
                                    window.removeEventListener('beforeunload', removeListener);
                                })
                                .catch(() => {
                                    showErrorProspectMessage();
                                    window.removeEventListener('beforeunload', removeListener);
                                });
                        })
                        .catch(() => {
                            showErrorProspectMessage();
                            window.removeEventListener('beforeunload', removeListener);
                        });
                })
                .catch(() => {
                    showErrorProspectMessage();
                    window.removeEventListener('beforeunload', removeListener);
                });
        })
        .catch((error) => {
            if (error.errors) {
                const fieldsError = Object.keys(error.errors).toString();
                messageError.querySelector('span').innerHTML = `${
                    messageError.querySelector('span').innerHTML
                } Controlla i campi: ${fieldsError}`;
            }
            showErrorProspectMessage();
            window.removeEventListener('beforeunload', removeListener);
        });
};

const setRetailPrice = (product_prices, elementSelector) => {
    const rrpElement = document.querySelector(elementSelector);
    if (product_prices && product_prices.length > 0) {
        const sparkData = JSON.parse(localStorage.getItem('sparkLayerData'));
        if (sparkData) {
            if (sparkData.userData.salesAgent) {
                if (sparkData.impersonatorUserData) {
                    const customerGroupStringArray = sparkData.impersonatorUserData.group.split('-');
                    const cleanCustomerGroup = `${customerGroupStringArray[customerGroupStringArray.length - 2]}-${
                        customerGroupStringArray[customerGroupStringArray.length - 1]
                    }`;
                    const foundProductPrice = product_prices.find((price) => price.id == cleanCustomerGroup);
                    if (foundProductPrice && rrpElement) {
                        rrpElement.style.display = 'flex';
                        rrpElement.querySelector('b').innerHTML = new Intl.NumberFormat('it-IT', {
                            style: 'currency',
                            currency: Shopify.currency.active,
                        }).format(foundProductPrice.price);
                    }
                } else {
                    const customerGroupStringArray = sparkData.userData.group.split('-');
                    const cleanCustomerGroup = `${customerGroupStringArray[customerGroupStringArray.length - 2]}-${
                        customerGroupStringArray[customerGroupStringArray.length - 1]
                    }`;
                    const foundProductPrice = product_prices.find((price) => price.id == cleanCustomerGroup);
                    if (foundProductPrice && rrpElement) {
                        rrpElement.style.display = 'flex';
                        rrpElement.querySelector('b').innerHTML = new Intl.NumberFormat('it-IT', {
                            style: 'currency',
                            currency: Shopify.currency.active,
                        }).format(foundProductPrice.price);
                    }
                }
            } else {
                const customerGroupStringArray = sparkData.userData.group.split('-');
                const cleanCustomerGroup = `${customerGroupStringArray[customerGroupStringArray.length - 2]}-${
                    customerGroupStringArray[customerGroupStringArray.length - 1]
                }`;
                const foundProductPrice = product_prices.find((price) => price.id == cleanCustomerGroup);
                if (foundProductPrice && rrpElement) {
                    rrpElement.style.display = 'flex';
                    rrpElement.querySelector('b').innerHTML = new Intl.NumberFormat('it-IT', {
                        style: 'currency',
                        currency: Shopify.currency.active,
                    }).format(foundProductPrice.price);
                }
            }
        }
    } else {
        if (rrpElement) {
            rrpElement.style.display = 'none';
        }
    }
};

const watchAnyObject = (object = {}, methods = [], callbackBefore = function () {}, callbackAfter = function () {}) => {
    for (let method of methods) {
        const original = object[method].bind(object);
        const newMethod = function (...args) {
            callbackBefore(method, ...args);
            const result = original.apply(null, args);
            callbackAfter(method, ...args);
            return result;
        };
        object[method] = newMethod.bind(object);
    }
};

const addPreOrderItems = async () => {
    //console.log('addPreOrderItems')
    const loaderModal = document.querySelector('.loader-modal');
    if (loaderModal) {
        document.querySelector('.loader-modal').style.display = 'block';
    }
    const cartType = localStorage.getItem('cartType') ? JSON.parse(localStorage.getItem('cartType')) : null;
    if (cartType) {
        const productsArray = cartType.preorder.map((product) => {
            return {
                sku: product.sku,
                quantity: product.quantity,
            };
        });
        const products = { products: [...productsArray] };
        const updatedCartType = {
            ...cartType,
            type: 'preorder',
            retail: [],
        };
        localStorage.setItem('cartType', JSON.stringify(updatedCartType));
        await window.spark.externalClearBasket();
        await window.spark.updateCart(products);
        document.querySelector('#preorderModal').classList.remove('open');
        document.querySelector('body').style.overflow = 'inherit';
        if (loaderModal) {
            document.querySelector('.loader-modal').style.display = 'none';
        }
    }
};

const addCatalogItems = async () => {
    // console.log('addCatalogItems');
    const loaderModal = document.querySelector('.loader-modal');
    if (loaderModal) {
        document.querySelector('.loader-modal').style.display = 'block';
    }
    const cartType = localStorage.getItem('cartType') ? JSON.parse(localStorage.getItem('cartType')) : null;
    if (cartType) {
        const productsArray = cartType.retail.map((product) => {
            return {
                sku: product.sku,
                quantity: product.quantity,
            };
        });
        const products = { products: [...productsArray] };
        const updatedCartType = {
            ...cartType,
            type: 'retail',
            preorder: [],
        };
        localStorage.setItem('cartType', JSON.stringify(updatedCartType));
        await window.spark.externalClearBasket();
        await window.spark.updateCart(products);
        document.querySelector('#preorderModal').classList.remove('open');
        document.querySelector('body').style.overflow = 'inherit';
        if (loaderModal) {
            document.querySelector('.loader-modal').style.display = 'none';
        }
    }
};

watchAnyObject(window.localStorage, ['setItem'], (method, key, ...args) => {
    if (key == 'sparkLayerCartData') {
        const preorderModal = document.querySelector('#preorderModal');
        const argsJSON = JSON.parse(args);
        const currentCart = localStorage.getItem('sparkLayerCartData')
            ? JSON.parse(localStorage.getItem('sparkLayerCartData'))
            : null;
        const cartType = localStorage.getItem('cartType') ? JSON.parse(localStorage.getItem('cartType')) : null;
        if ((!argsJSON || argsJSON.items.length == 0) && cartType) {
            console.log('enter');
            localStorage.removeItem('cartType');
            return;
        }
        if (argsJSON && currentCart && preorderModal && !preorderModal.classList.contains('open')) {
            const items = argsJSON.items;
            let preOrderItems = [];
            let retailItems = [];
            if (cartType) {
                preOrderItems = [...cartType.preorder];
                retailItems = [...cartType.retail];
            }
            for (const item of items) {
                const itemDataElement = document.getElementById(`ProductData_${item.externalId}`);
                if (itemDataElement) {
                    const itemData = JSON.parse(itemDataElement.innerHTML);
                    const tagFound = itemData.tags.find((tag) => tag.includes('lanci_'));
                    if (tagFound) {
                        const filteredPreorder = preOrderItems.filter((product) => product.id !== item.id);
                        preOrderItems = [...filteredPreorder, item];
                    } else {
                        const filteredRetail = retailItems.filter((product) => product.id !== item.id);
                        retailItems = [...filteredRetail, item];
                    }
                }
            }
            if (currentCart.items.length == 0) {
                const cartTypeObject = {
                    type: preOrderItems.length > 0 ? 'preorder' : 'retail',
                    preorder: [...preOrderItems],
                    retail: [...retailItems],
                };
                localStorage.setItem('cartType', JSON.stringify(cartTypeObject));
            } else {
                if (cartType) {
                    const updatedCartType = {
                        ...cartType,
                        preorder: [...preOrderItems],
                        retail: [...retailItems],
                    };
                    localStorage.setItem('cartType', JSON.stringify(updatedCartType));
                    if (
                        (cartType.retail.length > 0 && preOrderItems.length > 0) ||
                        (cartType.preorder.length > 0 && retailItems.length > 0)
                    ) {
                        document.querySelector('#preorderModal').classList.add('open');
                        document.querySelector('body').style.overflow = 'hidden';
                    }
                }
            }
        }
    }
    if (key == 'selectedBrand' || key == 'sparkLayerData') {
        if (window.spark) {
            window.spark.externalClearBasket();
        }
    }
});
